import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/available_step_address_life_cycle_by_address_id';

const { useQuery } = createQueryData({ endPoint });

const useRoomStepsQuery = ({ params: { addressId } = {}, options }) => {
  return useQuery({
    params: { addressId },
    options: {
      enabled: Boolean(addressId),
      staleTime: 0,
      ...options,
    },
  });
};

export { useRoomStepsQuery };
